import Vue from 'vue';
import VueRouter from 'vue-router';
import Page_1 from '../pages/Page_1/Page_1.vue';
import Chakanbaogao from '../pages/chakanbaogao/chakanbaogao.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Page_1',
    component: Page_1,
  },
  {
    path: '/chakanbaogao',
    name: 'chakanbaogao',
    component: Chakanbaogao,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
